module.exports = __webpack_public_path__ + "14af9df23ec82e79730eef8c6073c810.svg";